<template>
	<div id="SmartSessionEndPage">
		<div id="smartSessionEndInner">
			<div id="logoWrap">
				<img id="logo" src="../../public/img/ZBEdge-LO-lightBG.png" alt="ZBEdge" />
			</div>
			<h1 id="smartSessionEndTitle" data-testid="smartSessionEndTitle">{{ $t('smart_session_end_title') }}</h1>
			<!-- The localization pipeline converts newlines to <br /> (GetLocalizedStringsMediatr), so render as HTML. -->
			<div id="smartSessionEndText" data-testid="smartSessionEndText" v-html="$t('smart_session_end_text')"></div>
		</div>
	</div>
</template>

<script lang="ts">
	import * as Vue from 'vue';
	import WaitForAppDependencies from '../services/AppDependencyService';

	// Terminal page for an ended SMART embedded-launch (Epic iframe) session. Deliberately anonymous and chrome-less:
	// no page header, no footer (suppressed in App.vue via route meta), and no onward navigation — a framed session
	// cannot re-authenticate through B2C (X-Frame-Options: deny), so the only correct next step is to relaunch from the EHR.
	export default Vue.defineComponent({
		name: 'SmartSessionEndPage',
		created: async function () {
			await WaitForAppDependencies();
		}
	})
</script>

<style lang="scss">
	#SmartSessionEndPage {
		background: $light_gray;
		min-height: 100% !important;
		display: flex;
		flex: 2;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 40px 4%;
		box-sizing: border-box;

		#smartSessionEndInner {
			max-width: 640px;
			width: 100%;

			#logoWrap {
				margin-bottom: 32px;

				#logo {
					max-width: 100%;
					width: 300px;
				}
			}

			#smartSessionEndTitle {
				font-weight: 700;
				font-size: 32px;
				margin-bottom: 24px;
			}

			#smartSessionEndText {
				font-size: 1.1rem;
				line-height: 1.6;
			}
		}
	}
</style>
